module.exports = __webpack_public_path__ + "static/salesforce-b4bb3ba19dbd4104ff1d82281c86780c.jpg";